<template>
    <div class="app-container">
        <div v-if="state!='production'"
             style="background: red;color:white;font-size:12px;position:absolute;z-index: 100000;top:0;left: 0;padding: 1px 8px">
            ฐานข้อมูลทดสอบ
        </div>

        <IssueDialog></IssueDialog>

        <DatePicker></DatePicker>


        <main id="appBody" class="app-body">
            <router-view/>


            <v-app-bar class="header-top" fixed height="60" top>
                <template v-slot:default>
                    <v-tabs
                        center-active
                        centered
                        class="no-slider"
                        height="60"
                        slider-color="slider"
                        slider-size="5"
                    >
                        <v-tab :to="'/profile'">
                            <v-avatar color="teal">
                                <img
                                    v-if="$store.state.$user.picture"
                                    :src="$store.state.$user.picture"
                                />
                                <v-icon v-else>mdi-account-circle</v-icon>
                            </v-avatar>
                        </v-tab>


                        <TabForDialog v-for="(tab, index) in tabs" :tab="tab"></TabForDialog>
                    </v-tabs>
                </template>
            </v-app-bar>
        </main>
        <v-snackbar
            v-model="snackbar"
            :bottom="true"
            :color="snackbar_color"
            :right="true"
            :timeout="2000"
            :vertical="true"
        >
            <h5>{{ snackbar_title }}</h5>
            <br>
            {{ snackbar_text }}
            <v-btn
                text
                @click="snackbar = false"
            >
                ปิด
            </v-btn>
        </v-snackbar>
    </div>
</template>
<style lang="scss">
.app-body {
    //color: white;
    margin-top: 60px;
    max-height: calc(100vh - 60px);
    max-width: 100vw;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    background-color: transparent !important;
}

.header-top {
    z-index: 0 !important;
}

.no-slider {
    .v-slide-group__wrapper {
        /*background-color: #FFFFFF;*/
    }

    .v-slide-group__prev {
        display: none !important;
    }

    .v-tabs-slider-wrapper {
        top: 0 !important;

        .slider {
            /*background: linear-gradient(90deg, #6BD1ED 0%, #0054A4 100%);*/
        }
    }

    .v-tab {
        text-transform: none !important;
        padding-top: 5px;

        & .tab-content {
            display: grid;
            z-index: 9;
        }

        & .tab-img {
            margin: 0 auto;
        }

        &.v-tab--active {
            /*background-color: #273142;*/
        }
    }
}
</style>

<script>
import Api from '../providers/Api'
import IssueDialog from '../dialogs/IssueDialog'

import Helper from '../services/Helper'
import TabForDialog from '../components/TabForDialog'
import { gVariable } from '@/services/globalData'
import DatePicker from '@/dialogs/DatePicker'

export default {
    components: {
        DatePicker,
        TabForDialog,
        IssueDialog
    },
    data () {
        return {
            state: 'test',

            dialog: false,
            snackbar: false,
            snackbar_title: '',
            snackbar_color: 'error',
            snackbar_text: ''

        }
    },
    computed: {
        tabs: function () {
            return gVariable.tabs_array.filter(tab => tab.permissions.length === 0 || tab.permissions.includes(this.$store.state.$user.role))
        }
    },

    created () {
        if (!Helper.checkLogin()) {
            this.$store.state.intended = this.$route.fullPath
            this.$router.push('/login')
        } else {
            this.getMe()
            this.getConfig()

            if (this.$store.state.need_register_line) {
                this.dialog = true
            }
        }
        this.state = process.env.VUE_APP_STATE
        this.$root.$on('onSuccess', this.onSuccess)
        this.$root.$on('onWarning', this.onWarning)
        this.$root.$on('onError', this.onError)
    },

    methods: {

        onSuccess ({title, message}) {
            this.snackbar = true
            this.snackbar_title = title ? title : 'Success'
            this.snackbar_color = 'success'
            this.snackbar_text = message

        },
        onWarning ({title, message}) {
            this.snackbar = true
            this.snackbar_title = title ? title : 'Warning'
            this.snackbar_color = 'warning'
            this.snackbar_text = message
        },
        onError ({title, message}) {
            this.snackbar = true
            this.snackbar_title = title ? title : 'Error'
            this.snackbar_color = 'error'
            this.snackbar_text = message
        },
        getMe () {
            Helper.get('/api/me')
                .then(({data}) => {

                    this.$store.commit('current_user', data.data)

                    this.$vuetify.theme.dark = data.data.theme

                    // setTimeout(() => {this.getMe()}, 20000)
                })
                .catch(() => {
                    // setTimeout(() => {this.getMe()}, 20000)
                })
        },


        async getConfig () {
            const config = await Helper.get(Helper.setting.config.getListAPI)
                .then(({data}) => {
                    this.$store.commit('config', data)
                    return data
                })
        },

        logout () {
            this.$store.state.intended = null
            this.post('/api/logout')

            this.logOut()
        }

        // hasPermissions (permissions) {
        //   return permissions.length === 0 || _.intersection(permissions, this.$store.state.$user.permissions).length !== 0
        // },
        //
        // setPermission (permission) {
        //   this.page_permissions = permission
        // },
    },

    mixins: [
        Api
    ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
